import React from 'react';
import { trackPhoneClick, trackEmailClick, trackSocialClick, trackBookingClick } from '../utils/analytics';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* First Column - Logo Only */}
        <div className="footer-left">
          <a href="/" className="footer-logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_e76c0267-8aa9-430d-8c3c-8b45ddb37a9a/artifacts/jhvm0afx_Sereno%20logo%20DS%20cropped%20no%20background.png" 
              alt="Sereno Spa" 
              className="footer-logo"
            />
          </a>
        </div>

        {/* Second Column - Contact Information */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p>Sereno Spa</p>
          <p>43 Main St, Livingston Manor, NY 12758</p>
          <div className="contact-details">
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <a href="tel:845-439-1084" onClick={trackPhoneClick}>845-439-1084</a>
            </div>
            <div className="contact-item">
              <span className="contact-icon">✉️</span>
              <a href="mailto:jamiewaichman@serenodayspa.com" onClick={trackEmailClick}>jamiewaichman@serenodayspa.com</a>
            </div>
          </div>
        </div>

        {/* Center Section - Business Hours + Book Now Button */}
        <div className="footer-center">
          <div className="business-hours">
            <h3>Business Hours</h3>
            <p>Monday - Friday: 9:00 am - 6:00 pm</p>
            <p>Saturday: 10:00 am - 5:00 pm</p>
            <p>Sunday: 10:00 am - 3:00 pm</p>
          </div>
          
          <div className="footer-booking">
            <a 
              href="https://www.fresha.com/book-now/sereno-spa-xw34dhed/services?lid=2572885&share=true&pId=2492446" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-primary footer-book-btn"
              onClick={() => trackBookingClick('Footer Booking', 'Footer')}
            >
              Book Now
            </a>
          </div>
        </div>

        {/* Right Section - Social Media */}
        <div className="footer-right">
          <div className="footer-social">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a 
                href="https://www.facebook.com/share/17CSC2mU2R/?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon"
                onClick={() => trackSocialClick('Facebook')}
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a 
                href="https://www.instagram.com/sereno_day_spa/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon"
                onClick={() => trackSocialClick('Instagram')}
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 Sereno Spa. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;